import { SVGProps } from "react";

const ZenithIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_98737_35707)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.71787 4.97222C1.70199 5.00906 1.7392 4.89457 1.74995 4.85567L1.79182 4.704C2.22401 3.136 2.65602 1.568 3.08822 0L16.9955 0.0272399L1.62598 12.5283L8.64954 4.06574L3.37328 4.0807C3.27578 4.081 3.17819 4.0807 3.08088 4.08722C2.45512 4.14036 1.91296 4.51954 1.71786 4.97211"
        fill="#808285"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2402 8.57249C16.256 8.53566 15.8199 11.2363 15.0506 14.0281L0.536621 14.1091L16.2118 1.41406L9.18688 9.95656L14.4631 9.9416C14.5606 9.9413 14.6582 9.9416 14.7556 9.93507C15.3813 9.88194 16.0451 9.02521 16.2402 8.57264"
        fill="#ED1C24"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.46985 17.9984H0L1.70716 15.6801H0.575018L0.657027 15.0391H3.00899L1.306 17.3534H2.55233L2.46985 17.9984ZM2.93556 17.9984L3.31443 15.0391H5.02654L4.94362 15.6878H3.9742L3.9084 16.201H4.82233L4.74119 16.8359H3.82725L3.76323 17.3355H4.73261L4.64782 17.9984H2.93556ZM5.15133 17.9984L5.53006 15.0391H6.26501L7.12567 16.5613C7.14182 16.5923 7.1671 16.6544 7.20207 16.7482C7.23618 16.8421 7.2729 16.9532 7.31232 17.0829C7.31275 16.9601 7.31577 16.8511 7.32099 16.7551C7.32602 16.6599 7.33365 16.5751 7.34328 16.5004L7.53032 15.0391H8.26116L7.88243 17.9984H7.15145L6.29161 16.4701C6.27408 16.4391 6.24811 16.3771 6.21329 16.2833C6.17903 16.1893 6.14289 16.0796 6.10443 15.9526C6.10366 16.0769 6.10059 16.1866 6.09545 16.2825C6.09043 16.3777 6.08279 16.4626 6.07316 16.5372L5.88608 17.9984H5.15133ZM8.50073 17.9984L8.87945 15.0391H9.64894L9.27002 17.9984H8.50073ZM10.287 17.9984L10.5763 15.7388H9.95017L10.0398 15.0391H12.0537L11.9641 15.7388H11.3379L11.0487 17.9984H10.287ZM12.0467 17.9984L12.4254 15.0391H13.1872L13.0399 16.1893H14.055L14.2022 15.0391H14.9657L14.5868 17.9984H13.8234L13.9776 16.7937H12.9626L12.8083 17.9984H12.0467Z"
        fill="#808285"
      />
    </g>
    <defs>
      <clipPath id="clip0_98737_35707">
        <rect width="16.9954" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ZenithIcon;
